/**
 * organization permission service
 */

import Resource from './resource'

export default new Resource('orgpermissions')



// WEBPACK FOOTER //
// ./src/libraries/services/orgpermission.js